// First tried this example but this caused some issues in the protected route component:
// https://edupala.com/react-router-navigate-outside-component/

// This is now the implmentation the app has integrated
// https://github.com/lagunovsky/redux-react-router/blob/main/examples/basic/history.tsx

import { createBrowserHistory, } from 'history';
export default createBrowserHistory();
